import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { DeviceOption } from 'src/app/pages/phones/models/device-option.interface';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { deviceOptionActions } from '../state/device-option.actions';
import { deviceOptionSelectors } from '../state/device-option.reducer';

@Directive({
   selector: '[ndtDeviceSelect]',
   standalone: false,
})
export class DeviceSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   @Input() deviceTypesToExclude: (number | string)[];

   @Input() deviceTypesToInclude: number[];

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<DeviceOption>,
      private statusService: NgrxEagerSelectService<AppState, DeviceOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] | undefined;

      if (this.accountId) {
         staticFilterOverride = [`PhoneId is null AND AccountId = ${this.accountId}`];
      }
      if (this.deviceTypesToExclude) {
         if (!staticFilterOverride) {
            staticFilterOverride = [];
         }
         staticFilterOverride.push(`DeviceTypeId not in (${this.deviceTypesToExclude.join(',')})`);
      }
      if (this.deviceTypesToInclude) {
         if (!staticFilterOverride) {
            staticFilterOverride = [];
         }
         staticFilterOverride.push(`DeviceTypeId in (${this.deviceTypesToInclude.join(',')})`);
      }
      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            deviceOptionActions,
            deviceOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('deviceId', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
